import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {HasContactBaseMixin} from "../../widget/mixins/HasContactBaseMixin.jsx";
import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";

export default class ClientContactTab extends HasContactBaseMixin(ClientsEditorBase) {
  static get $name() {
    return "ClientContactTab";
  }

  static get type() {
    return "clientcontacttab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientEditorContactGridState;
  }

  get recordType() {
    return "clientId";
  }

  getStoreData() {
    return this.record.contacts;
  }

  getStore() {
    return this.project.clientContactsStore;
  }

  getEntityStoreKey() {
    return STORE_KEYS.clientStore;
  }
}

ClientContactTab.initClass();